import { createReducer } from './utils';
import { translate as t } from '@/core/i18n/translate';
import {
  GET_SELF_ASSESSMENT_RESULTS_FAILURE,
  GET_SELF_ASSESSMENT_RESULTS_REQUEST,
  GET_SELF_ASSESSMENT_RESULTS_SUCCESS,
  SNACK_SET,
} from './constants';
import { Action, SelfAssessmentResultsState, ThunkAPI } from '../types/state';
import { SelfAssessmentResultsPayload } from '@shared/schema';

const defaultState: SelfAssessmentResultsState = {
  loading: false,
  error: null,
  data: null,
};

export const reducer = createReducer(defaultState, {
  [GET_SELF_ASSESSMENT_RESULTS_REQUEST]: handleRequest,
  [GET_SELF_ASSESSMENT_RESULTS_SUCCESS]: handleSuccess,
  [GET_SELF_ASSESSMENT_RESULTS_FAILURE]: handleFailure,
});

function handleRequest(state: SelfAssessmentResultsState): SelfAssessmentResultsState {
  return { ...state, loading: true, error: null };
}

function handleSuccess(
  state: SelfAssessmentResultsState,
  action: Action<unknown>,
): SelfAssessmentResultsState {
  const payload = action.payload as { data?: SelfAssessmentResultsPayload } | undefined;
  return { ...state, loading: false, data: payload?.data ?? null, error: null };
}

function handleFailure(
  state: SelfAssessmentResultsState,
  action: Action<unknown>,
): SelfAssessmentResultsState {
  const payload = action.payload as { errorMessage?: string } | undefined;
  return {
    ...state,
    loading: false,
    error: payload?.errorMessage || t('apiFeedback.plans.genericError'),
  };
}

export function fetchSelfAssessmentResults(fulfillmentVersionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: GET_SELF_ASSESSMENT_RESULTS_REQUEST });
    try {
      const data = await dataSource.getSelfAssessmentResults(fulfillmentVersionId);
      dispatch({ type: GET_SELF_ASSESSMENT_RESULTS_SUCCESS, payload: { data } });
    } catch (error) {
      console.error('[selfAssessmentResults] fetch error', error);
      dispatch({
        type: GET_SELF_ASSESSMENT_RESULTS_FAILURE,
        payload: { errorMessage: (error as Error).message },
      });
      const snack = {
        open: true,
        message: t('apiFeedback.selfAssessmentResults.fetchError'),
        severity: 'error' as const,
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}
